'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = makeExponentialDelayGenerator;
function makeExponentialDelayGenerator(_ref) {
  var basis = _ref.basis;

  return function exponentialDelayGenerator(n) {
    if (n === 0) return 0;
    if (n === 1) return basis;

    return exponentialDelayGenerator(n - 1) * 2;
  };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-lib/static-1.28/js/time/makeExponentialDelayGenerator.js
// module id = 297
// module chunks = 0 1